import {ICommonUseKnowledge} from './../../../../../interface';
import {EventEmitter} from 'events';

export const events = new EventEmitter();
export const ADD_QUICK_USE = 'add_quick_user';
export const REMOVE_QUICK_USE = 'remove_quick_user';
export const REFRESH_RECENT_LIST = 'refresh_recent_list';
export const DELETE_STAR_GROUP_SUCCESS = 'delete_star_group_success';
export const RENAME_STAR_GROUP_SUCCESS = 'rename_star_group_success';

export const EVENT_FROM = {
    quick: 'quick',
    list: 'list',
} as const;

export type IEventFrom = typeof EVENT_FROM[keyof typeof EVENT_FROM];
export function addQuickUse(knowledge: ICommonUseKnowledge[], from: IEventFrom) {
    events.emit(ADD_QUICK_USE, {
        knowledge, from,
    });
}

export function removeQuickUse(knowledge: ICommonUseKnowledge, from: IEventFrom) {
    events.emit(REMOVE_QUICK_USE, {
        knowledge, from,
    });
}

export function refreshRecentList() {
    events.emit(REFRESH_RECENT_LIST);
}

export function deleteStarGroupSuccess(labelId: number) {
    events.emit(DELETE_STAR_GROUP_SUCCESS, labelId);
}

export function renameStarGroupSuccess(labelId: number, name: string) {
    events.emit(RENAME_STAR_GROUP_SUCCESS, labelId, name);
}
